import React from "react";
import {
  UpdateSizeMutationVariables,
  useSizeQuery,
  useUpdateSizeMutation,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updateMutation] = useUpdateSizeMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = useSizeQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to={"/size"} replace />;
  }

  const handleUpdate = async (data: UpdateSizeMutationVariables) => {
    try {
      await updateMutation({
        variables: {
          ...data,
        },
      });

      return toast({
        status: "success",
        title: "Başarılı",
        description: "Boyut güncellendi",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/size");
        },
      });
    } catch (error: any) {
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };

  return (
    <Form actionType="UPDATE" data={data?.size} id={id} handleUpdate={handleUpdate} />
  );
};

export default Update;
